// action - state management
import setAuthToken from "Helpers/setAuthToken";
import {
  ADMIN_LOADED,
  AUTH_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  LOGIN_2FA,
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  token: localStorage.getItem("BDE_TOKEN"),
  isAuthenticated: false,
  loading: true,
  admin: {},
};

// const accountReducer = (state = initialState, action) => {
export const accountReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_2FA:
      return {
        ...state,
        isAuthenticated: false,
        loading: true,
      };
    case LOGIN_SUCCESS:
      localStorage.setItem("BDE_TOKEN", payload.token);
      // setAuthToken(payload.token);
      // console.log("LOGIN_SUCCESS : payload", payload.token);
      return {
        ...state,
        token: payload?.token,
        isAuthenticated: true,
        loading: false,
      };
    case ADMIN_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        admin: payload,
      };
    case LOGOUT_SUCCESS:
      localStorage.removeItem("BDE_TOKEN");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: true,
      };
    case AUTH_FAIL:
      localStorage.removeItem("BDE_TOKEN");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: true,
        admin: {},
      };
    default:
      return state;
  }
}

export default accountReducer;
